// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { TextareaTokens } from './type';

const textareaTokens: TextareaTokens = {
  textareaFontSize: '14/regular',
  textareaBorderRadius: 'Radius-4',
  textareaPaddingX: 'Padding-8',
  textareaPaddingY: 'Padding-4',
  textareaSmallFontSize: '12/regular',
  textareaSmallPaddingX: 'Padding-8',
  textareaSmallPaddingY: 'Padding-1',
  textareaLargeFontSize: '16/regular',
  textareaLargePaddingX: 'Padding-12',
  textareaLargePaddingY: 'Padding-7',
  textareaFontColor: 'Neutral-text-5',
  textareaPlaceholderColor: 'Neutral-text-2',
  textareaBorderColor: 'Neutral-border-2',
  textareaBackgroundColor: 'Neutral-fill-1',
  textareaHoverBorderColor: 'Brand-6',
  textareaFocusBorderColor: 'Brand-7',
  textareaFocusShadow: 'Brand-2',
  textareaDisabledFontColor: 'Neutral-text-2',
  textareaDisabledPlaceholderColor: 'Neutral-text-2',
  textareaDisabledBorderColor: 'Neutral-border-1',
  textareaDisabledBackgroundColor: 'Neutral-fill-2',
  textareaErrorBorderColor: 'Danger-6',
  textareaErrorFocusShadow: 'Danger-1',
  textareaInfoFontColor: 'Brand-6',
  textareaInfoBackgroundColor: 'Neutral-fill-1',
  textareaInfoBorderColor: 'Neutral-border-2',
  textareaInfoErrorFontColor: 'Danger-6',
  textareaInfoErrorBackgroundColor: 'Danger-1',
  textareaInfoErrorBorderColor: 'Danger-6',
};

export default textareaTokens;
